import { Nullable } from 'maven-ui-kit/core/types';

import { LocalKey } from 'constants/local-storage';

import { loadState, removeState, saveState } from 'utils/localStorage';

export const useLocalStorage = <T>(localKey: LocalKey) => {
  const setValue = (newValue: T) => {
    saveState(localKey, newValue);
  };

  const getValue = (): Nullable<T> => {
    return loadState<T>(localKey);
  };

  const removeValue = () => {
    removeState(localKey);
  };

  return {
    setValue,
    getValue,
    removeValue,
  };
};
